import omitBy from 'lodash/omitBy';

import { Button } from '@/components/ui/button';
import { FilterSelect } from '@/modules/common/components';

import { GcrFormOptions, TableFiltersType } from '../types';

interface TableFiltersProps {
  options: GcrFormOptions;
  filters: Partial<TableFiltersType>;
  setFilters: (filters: Partial<TableFiltersType>) => void;
}

export function TableFilters({
  options,
  filters,
  setFilters,
}: TableFiltersProps) {
  const handleFilterChange = (
    filter: keyof TableFiltersType,
    value: string
  ) => {
    setFilters(omitBy({ ...filters, [filter]: value }, (v) => v === ''));
  };

  return (
    <div className="flex gap-4 pb-5 flex-wrap max-w-[1000px]">
      <div className="flex-1">
        <FilterSelect
          options={options.colors}
          label="Color"
          value={filters.color}
          onChange={(value) => handleFilterChange('color', value)}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={options.sizes}
          label="Size"
          value={filters.size}
          onChange={(value) => handleFilterChange('size', value)}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={options.types}
          label="Type"
          value={filters.type}
          onChange={(value) => handleFilterChange('type', value)}
        />
      </div>

      <div className="flex-1">
        <FilterSelect
          options={options.printers}
          label="Printer"
          value={filters.printer}
          onChange={(value) => handleFilterChange('printer', value)}
        />
      </div>

      <div className="col-span-3 sm:col-span-1">
        <Button
          variant="outline"
          className="w-full"
          onClick={() => setFilters({})}
        >
          Clear Filters
        </Button>
      </div>
    </div>
  );
}
